import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getTrips } from '../../services/TripsService';
import { TripsResponse } from '../../types/Trips';

/**
 * Trips of a fixed past window, used to cut the map route history into per-trip legs.
 * Unlike useGetTrips this neither polls nor merges live active-trip data: the window is
 * historical, so the answer does not change while it is on screen.
 */
function useGetTripsRange(
  fleetId: string,
  query: string,
  enabled = true,
): UseQueryResult<TripsResponse> {
  return useQuery(
    ['trips-range', fleetId, query],
    async (): Promise<TripsResponse> => getTrips(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      enabled: enabled && !!fleetId && !!query,
    },
  );
}

export default useGetTripsRange;
